export function checkIsOverflowed(el) {
    return el.scrollWidth != Math.max(el.offsetWidth, el.clientWidth);
}
